import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import { signUp } from "@/backend.api";
import identityResult from "@/models/identityResult";
import { useMessage, NInput, NFormItem, NButton, NResult, NForm } from "naive-ui";


export default /*@__PURE__*/_defineComponent({
  __name: 'Register',
  setup(__props) {

const formRef = ref(null) as any;
const message = useMessage();
let isLoading = ref(false);
let isFinished = ref(false);

const size = ref("medium");
const formValue = ref({
    email: ""
});
const rules = {
    email: {
        required: true,
        message: "Пожалуйста введите почту",
        trigger: ["input"],
        type: "email"
    }
};

const handleSubmitButton = (e: any) => {
    e.preventDefault();
    formRef.value?.validate(async (errors: any) => {
        if (!errors) {
            isLoading.value = true;
            const promise = signUp(formRef.value.model.email);
            promise
                .then((response) => {
                    const result = new identityResult(response.data);
                    if (result.succeeded) {
                        isFinished.value = true;
                    } else {
                        result.getDescriptions();
                        message.error(result.getDescriptions());
                    }
                })
                .finally(() => {
                    isLoading.value = false;
                });
        }
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_unref(NForm), {
      className: "form",
      ref_key: "formRef",
      ref: formRef,
      model: formValue.value,
      rules: rules,
      size: size.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(NFormItem), { path: "email" }, {
          default: _withCtx(() => [
            _createVNode(_unref(NInput), {
              value: formValue.value.email,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formValue.value.email) = $event)),
              size: "large",
              placeholder: "Введите адрес email",
              "show-require-mark": "",
              label: "test"
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_unref(NButton), {
          size: "large",
          block: "",
          strong: "",
          loading: _unref(isLoading),
          secondary: "",
          type: "success",
          onClick: handleSubmitButton
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" Зарегистрироваться ")
          ])),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }, 8, ["model", "size"]), [
      [_vShow, !_unref(isFinished)]
    ]),
    _withDirectives(_createVNode(_unref(NResult), {
      size: "small",
      status: "success",
      title: "Регистрация прошла успешно",
      description: "На вашу почту отправлено сообщение с информацией для входа."
    }, null, 512), [
      [_vShow, _unref(isFinished)]
    ])
  ], 64))
}
}

})